import {
	ugcPersonaByID,
	ugcPersonaCreate,
	ugcPersonaDestroy,
	ugcPersonasList,
	ugcPersonaUpdate,
} from '@/services/ai/ugcPersonas.service'

export default {
	namespaced: true,
	state: {
		// UGC PERSONAS
		ugcPersonasList: {
			meta: {
				pagination: {
					total: 0,
				},
			},
		},
		ugcPersona: {},

		// STATUS UGC PERSONAS
		ugcPersonasStatus: 'pending',
		ugcPersonasSaveStatus: 'init',
		ugcPersonasDeleteStatus: 'init',
	},
	getters: {
		// UGC PERSONAS
		getUgcPersonasList(state) {
			return state.ugcPersonasList
		},
		getUgcPersona(state) {
			return state.ugcPersona
		},

		// STATUS UGC PERSONAS
		getUgcPersonasDeleteStatus(state) {
			return state.ugcPersonasDeleteStatus
		},
		getUgcPersonasSaveStatus(state) {
			return state.ugcPersonasSaveStatus
		},
		getUgcPersonasStatus(state) {
			return state.ugcPersonasStatus
		},
	},
	mutations: {
		// UGC PERSONAS
		UGC_PERSONAS_LIST(state, value) {
			state.ugcPersonasList = value
		},
		SET_UGC_PERSONA(state, value) {
			state.ugcPersona = value
		},

		// STATUS UGC PERSONAS
		UGC_PERSONAS_STATUS(state, value) {
			state.ugcPersonasStatus = value
		},
		UGC_PERSONA_SAVE_STATUS(state, value) {
			state.ugcPersonasSaveStatus = value
		},
		UGC_PERSONA_DELETE_STATUS(state, value) {
			state.ugcPersonasDeleteStatus = value
		},
	},
	actions: {
		// UGC PERSONAS
		async fetchUgcPersonasList({ commit }, params) {
			window.scrollTo({ top: 0, behavior: 'smooth' })
			commit('UGC_PERSONAS_STATUS', 'pending')
			commit('UGC_PERSONAS_LIST', {
				meta: {
					pagination: {
						total: 0,
					},
				},
			})
			try {
				const { data } = await ugcPersonasList(params)
				commit('UGC_PERSONAS_STATUS', 'init')
				commit('UGC_PERSONAS_LIST', data)
				return data
			} catch (error) {
				commit('UGC_PERSONAS_STATUS', 'init')
				throw error
			}
		},
		async fetchUgcPersonaByID({ commit }, params) {
			commit('UGC_PERSONAS_STATUS', 'pending')
			try {
				const { data } = await ugcPersonaByID(params)
				commit('UGC_PERSONAS_STATUS', 'init')
				commit('SET_UGC_PERSONA', data.data)
				return data
			} catch (error) {
				commit('UGC_PERSONAS_STATUS', 'init')

				return error
			}
		},
		async saveNewUgcPersona({ commit }, params) {
			commit('UGC_PERSONA_SAVE_STATUS', 'pending')
			try {
				const { data } = await ugcPersonaCreate(params)
				commit('UGC_PERSONA_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('UGC_PERSONA_SAVE_STATUS', 'init')
				throw error
			}
		},
		async updateUgcPersona({ commit }, params) {
			commit('UGC_PERSONA_SAVE_STATUS', 'pending')
			try {
				const { data } = await ugcPersonaUpdate(params)
				commit('UGC_PERSONA_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('UGC_PERSONA_SAVE_STATUS', 'init')
				throw error
			}
		},
		async deleteUgcPersonaByID({ commit }, params) {
			commit('UGC_PERSONA_DELETE_STATUS', 'pending')
			try {
				const { data } = await ugcPersonaDestroy(params)
				commit('UGC_PERSONA_DELETE_STATUS', 'init')
				return data
			} catch (error) {
				commit('UGC_PERSONA_DELETE_STATUS', 'error')

				return error
			}
		},
	},
}
